import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Header } from 'src/features/header/Header';
import { Footer } from 'src/features/footer/Footer';

import { Breadcrumbs } from 'src/components';

import { ROUTE } from 'src/constants/routes';
import { APP_LANGUAGES } from 'src/constants';

import './appLayout.scss';

export const AppLayout = (props) => {
  const { children } = props;

  const { pathname, search } = useLocation();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const params = useParams();
  const language = params?.language;

  console.log('search', search);

  useEffect(() => {
    const canControlScrollRestoration = 'scrollRestoration' in window.history;

    if (canControlScrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (language) {
      const findedLanguage = APP_LANGUAGES.find((item) => item === language) || 'en';

      i18n.changeLanguage(findedLanguage);

      const updatedPath = pathname.replace(/^\/[a-z]{2}(?=\/)/i, findedLanguage) + search;

      navigate(updatedPath);
    } else {
      i18n.changeLanguage('en');
    }
  }, [i18n, language, navigate, pathname, search]);

  const routes = [ROUTE.HOME];

  const isVisibleBreadcrumbs = routes.includes(pathname);

  return (
    <div className="app-layout">
      <Header />
      {!isVisibleBreadcrumbs && <Breadcrumbs />}
      {children || <Outlet />}
      <Footer />
    </div>
  );
};
